<template>
	<v-dialog v-model="show" max-width="900" persistent>
		<v-card>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 class="title mb-3">
						{{ $t('labels.partnerEmailAddress') }}: {{ partnerEmail }}
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12>
						<Dropdown
							v-model="template"
							:data="templates"
							:label="$t('fields.template')"></Dropdown>
					</v-flex>
					<template v-if="templateLoaded">
						<v-flex xs12>
							<InputField v-model="subject"></InputField>
						</v-flex>
						<v-flex xs12>
							<Editor
								:init="$tinymceInit"
								v-model="body"></Editor>
						</v-flex>
					</template>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="reset">{{ $t('buttons.cancel') }}</v-btn>
				<v-btn @click="send">{{ $t('buttons.ok') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import InputField from "./trinkets/InputField";
import Dropdown from "./trinkets/Dropdown";
import Editor from '@tinymce/tinymce-vue';

export default {
	name: "PartnerEmailModal",
	props: ['show', 'partner', 'opportunity'],
	components: {
		InputField,
		Dropdown,
		Editor
	},
	data: function () {
		return {
			partnerEmail: '',
			subject: '',
			body: '',
			template: null,
			templates: [
				{
					label: this.$t('emailTemplates.priceChange'),
					value: 'price_change'
				},
				{
					label: this.$t('emailTemplates.removeFromOffer'),
					value: 'remove_from_offer'
				}
			],
			templateLoaded: false
		}
	},
	watch: {
		partner: function () {
			this.loadTemplate();
		},
		opportunity: function () {
			this.loadTemplate();
		},
		template: function () {
			this.loadTemplate();
		},
		show: function () {
			this.template = null;
			if (this.show) {
				this.$APICall('get', 'partners/' + this.partner, {}, (data, success) => {
					if (success) {
						this.partnerEmail = data.email;
					}
				}, false);
			} else {
				this.templateLoaded = false;
			}
		}
	},
	methods: {
		loadTemplate() {
			if (this.partner !== null && this.opportunity !== null && this.template !== null) {
				let vm = this;
				this.$APICall('get', 'partners-email-template/' + this.partner + '/' + this.opportunity + '/' + this.template, {}, (data, success) => {
					if (success) {
						vm.subject = data.subject;
						vm.body = data.body;
						vm.$nextTick(() => {
							vm.templateLoaded = true;
						});
					}
				}, false);
			}
		},
		reset() {
			let vm = this;
			this.$verify(this.$t('alerts.emailCancelQuestion'), (result) => {
				if (result) {
					vm.subject = '';
					vm.body = '';
					vm.$emit('callback');

				}
			});
		},
		send() {
			let vm = this;
			this.$verify(this.$t('alerts.emailSendQuestion'), (result) => {
				if (result) {
					let payLoad = {
						destinations: [this.partnerEmail],
						subject: this.subject,
						body: this.body
					}
					this.$APICall('post', 'email', payLoad, (data, success) => {
						if (success) {
							if (data.message_id != '') {
								vm.$notify(this.$t('alerts.emailSent'));
								this.$emit('callback');
							} else {
								vm.$alert(data.error);
								vm.$emit('callback');
							}
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
	},
	mounted() {

	}
}
</script>

<style scoped>

</style>
